import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ElectroList, Electro,LarList, ContractDetail, ElectroEnabledManuals, ElectroContractContentData } from '../models/electrocontract';
import { ElectroService } from './electro.services';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { InspectionList, ElectroInspection, CheckList, InspectionChartModel } from '../models/electroinspection';
import { ElectroDeviation, DeviationList } from '../models/electrodeviation';
import { ElectroInstallationService } from './electro-installation.services';
import { TreeData } from 'src/app/kuba/common/models';
import { ElectroDocumentService } from './electro-document.services';
import { ElectroInstallationBuliding } from '../models/electroinstallation';
import { ElectroChecklistCompletion } from '../models/electrochecklistcompletion';
import { ElectroFeature } from '../models/electrofeatures';
import { HelperService } from 'src/app/_services/helper.service';
import { Rights, FeatureKey } from 'src/app/_models';
import { MeasureProtocolService } from 'src/app/kuba/measure-protocol/services/measure-protocol.services';

@Injectable()
export class ElectroListByBusinessResolver {
    constructor(private backend: ElectroService) { }
    resolve() {
        if(BaseServices.roleId == '3' || HelperService.ApprovalPersonRightsCheck(
            JSON.parse(BaseServices.getUserRights()), Rights.SERVICE_LEADER_ELECTRO)){
                return this.backend.getContractsbybusiness();
        }
        return this.backend.getContractByUserAssociated();
    }
}
@Injectable()
export class ContractWorkersResolver{
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.getContractWorkers();
    }
}
@Injectable()
export class ContractContentResolver{
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.getContractContent();
    }

}
@Injectable()
export class ElectroEditResolver {
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return +route.parent.params['cid'] > 0 ?
            this.backend.getContractById(+route.parent.params['cid']) : null;
    }
}
@Injectable()
export class ControlScopeBuildingsResolver {
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return +route.parent.params['cid'] > 0 ?
            this.backend.getInstallationBuilding(+route.parent.params['cid']) : null;
    }
}

@Injectable()
export class InspectionScopeResolver {
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return +route.parent.params['cid'] > 0 ?
            this.backend.getInspectionScope(+route.parent.params['cid']) : null;
    }
}

@Injectable()
export class InspecitonChartResolver{
    constructor(private backend: ElectroService) { }
    resolve() {
        return this.backend.getInspectionChartData();
    }
}
@Injectable()
export class InspectionListByBusinessResolver {
    constructor(private backend: ElectroService) { }
    resolve() {
        return this.backend.getInspectionsbybusiness();
    }
}

@Injectable()
export class AssignedWorkersResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getAssignedWorkers(+route.parent.params['cid']);
    }
}

@Injectable()
export class AssignedWorkersByInspectionResolver{
    
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return +route.params['Iid'] > 0 ?
        this.backend.getAssignedWorkersByInspection(+route.params['Iid']): null;
    }
}
@Injectable()
export class BuildingsByInspectionResolver{
    
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return +route.params['Iid'] > 0 ?
        this.backend.getBuildingsByInspection(+route.params['Iid']): null;
    }
}
@Injectable()
export class AssignedTasksResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        let insId = +route.parent.params['Iid'] > 0 ? +route.parent.params['Iid'] : 0;
        return this.backend.getAssignedTasks(+route.parent.params['cid'], insId);
    }
}
@Injectable()
export class ContractClientContactInfoResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getClientContactInfo(+route.parent.params['cid']);
    }
}

@Injectable()
export class InspectionEditResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return +route.parent.params['Iid'] > 0 ?
            this.backend.getInspectionById(+route.parent.params['Iid']) : null;
    }
}

@Injectable()
export class DeviationListByBusinessResolver{
    constructor(private backend: ElectroService){}
    resolve(): Observable<DeviationList[]>{
        return this.backend.getDeviationByBusiness();
    }
}

@Injectable()
export class DevInspectionResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return +route.parent.parent.params['Iid'] > 0 ?
            this.backend.getInspectionById(+route.parent.parent.params['Iid']) : null;
    }
}

@Injectable()
export class DeviationEditResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return +route.params['Did'] > 0 ?
        this.backend.getDeviationById(+route.params['Did']) : null;
    }
}
//Organization and Responsibilities
@Injectable()
export class OrganizationListByBusinessResolver {
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot): any {
        return this.backend.getArticlesByBusinessFeature(ElectroFeature.ORGANIZATION_AND_RESPONSIBILTIES,
            BaseServices.UserRole !== 'Admin'? +route.params['Id'] : 0);
    }
}

@Injectable()
export class InternalControlListByBusinessResolver {
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot): any {
        return this.backend.getArticlesByBusinessFeature(ElectroFeature.INTERNAL_CONTROL_SYSTEM,
            BaseServices.UserRole !== 'Admin'? +route.params['Id'] : 0);
    }
}

@Injectable()
export class LawsListByBusinessResolver {
    constructor(private backend: ElectroService) { }
    resolve(): any {
        return this.backend.getLawsList();
    }
}

@Injectable()
export class RegulationsListByBusinessResolver {
    constructor(private backend: ElectroService) { }
    resolve(): any {
        return this.backend.getRegulationsList();
    }
}

@Injectable()
export class InspectionReportListByBusinessResolver {
    constructor(private backend: ElectroService) { }
    resolve(): any {
        return this.backend.getInspectionReportbybusiness();
    }
}

@Injectable()
export class ReportCheckListResolver {
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.getReportChecklist(+route.parent.params['Id']);
    }
}
@Injectable()
export class ElectroInfoResolver {
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return +route.parent.parent.params['cid'] > 0 ?
            this.backend.getContractInfoById(+route.parent.parent.params['cid']) : null;
    }
}
@Injectable()
export class ElectroContractDetailById{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getContractDetailById(+route.parent.parent.params['cid']);
    }
}

@Injectable()
export class ElectroManualListResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){  
        return this.backend.getElectroManualByContractId(+route.parent.params['cid'],route.url[0].path === "editcontent" ?1 :2);
    }
}

@Injectable()
export class ElectroEnabledManualsResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getEnabledElectroManualByContractId(+route.parent.params['cid']);
    }
}

// installation
@Injectable()
export class EnabledInstallationFormsResolver{
    constructor(private backend: ElectroInstallationService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getEnabledForms(+route.parent.parent.params['cid']);
    }
}

@Injectable()
export class InstallationFormsBuildingsTreeResolver{
    constructor(private backend: ElectroInstallationService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getInstallationFormsBuildingsTree(+route.parent.parent.params['cid']);
    }
}
@Injectable()
export class ElectroArchiveTreeDataResolver {
    constructor(private backend: ElectroService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<TreeData[]> {
        return this.backend.getElectroArchiveTree(BaseServices.BusinessId,+route.parent.params['cid']);
    }
}

@Injectable()
export class EnabledChecklistResolver{
    constructor(private backend: ElectroDocumentService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getContractEnabledChecklists(+route.parent.params['cid']);
    }
}

//settings
@Injectable()
export class ElectroSettingsResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getSettingsById();
    }
}

@Injectable()
export class ElectroCompletionChecklistDataResolver{
    constructor(private backend: ElectroDocumentService){}
    resolve(route: ActivatedRouteSnapshot){
        return +route.params['cClId'] ? 
        this.backend.getCompletionChecklistdata(+route.params['cClId']) : null;
    }
}

@Injectable()
export class ContractBuildingsResolver{
    constructor(private backend: ElectroInstallationService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroInstallationBuliding[]> {
        return this.backend.getContractBuildings(+route.params['cid']);
    }
}

@Injectable()
export class EnabledReportsResolver{
    constructor(private backend: ElectroDocumentService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getContractEnabledChecklists(+route.params['cid']);
    }
}

@Injectable()
export class ChecklistBuildingtreeResolver{
    constructor(private backend: ElectroDocumentService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getInspectionChecklistBuildingtree(+route.parent.params['cid'],+route.parent.params['Iid']);
    }
}

@Injectable()
export class InstallerInspectionByContractResolver{
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getInstallerInspectionsbyContract(+route.parent.parent.params['Id']);
    }
}

@Injectable()
export class ClientInspectionByContractResolver{
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getClientInspectionsbyContract(+route.parent.parent.params['Id']);
    }
}
@Injectable()
export class DeviationsbyInspectionResolver{
    constructor(private backend: ElectroService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getDeviationsbyInspection(+route.parent.parent.params['Iid']);
    }
}

@Injectable()
export class DeviationListByContractResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot): Observable<DeviationList[]>{
        return this.backend.getDeviationsbyContract(+route.parent.parent.params['Id']);
    }
}

@Injectable()
export class ElectroEnabledFeaturesResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getEnabledElectroManualByContractId(+route.params['cid']);
    }
}

@Injectable()
export class InspectionEnabledTasksResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getInspectionTasks(+route.parent.params['Iid']);
    }
}

@Injectable()
export class EnabledFormsResolver{
    constructor(private backend: ElectroInstallationService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getEnabledForms(+route.params['cid']);
    }
}
@Injectable()
export class ViolatedParaResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.GetViolatedParaReference();
    }
}
@Injectable()
export class ClientNumListResolver {
    constructor(private backend: ElectroService) { }
    resolve() {
        return this.backend.getClientWithClientNum();
    }
}

@Injectable()
export class ClientUsersBySelfInspectionResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return +route.parent.params['cid'] > 0 ?
         this.backend.GetClientUsersBySelfInspection(+route.parent.params['cid']): null;
    }
}
@Injectable()
export class ElectroMeasureProtocolResolver{
    constructor(private backend: MeasureProtocolService){}
    resolve(route: ActivatedRouteSnapshot){
        if(+route.params['cid']){
            return this.backend.getAllMeasureProtocol(FeatureKey.ELECTRO,+route.params['cid'], 'KUNDE_EL');
        }else{
            return this.backend.getAllMeasureProtocol(FeatureKey.ELECTRO,
                +route.parent.parent.params['cid'], 'KUNDE_EL');
        }
    }
}
@Injectable()
export class DeviationClientInfoResolver{
    constructor(private backend: ElectroService){}
    resolve(route: ActivatedRouteSnapshot){
        return this.backend.getClientContactInfoByInspection(+route.params['Iid']);
    }
}